export default __webpack_public_path__ + "static/media/Gida of Dark Terror.a23c0a73.jpg";